const defaults = {
    showFollowLiveroom: false,
    qrcodes: {},
    liveroom: {},
    callback: null
};


export default (state = defaults, action) => {
    switch (action.type) {
        case 'SHOW_FOLLOW_LIVEROOM':
            return {
                ...state, showFollowLiveroom: true,
                qrcodes: action.payload.qrcodes,
                liveroom: action.payload.liveroom,
                callback: action.payload.callback,
                lectureId: action.payload.lectureId,
                from: action.payload.from,
            };
        case 'HIDE_FOLLOW_LIVEROOM':
            return {...state, showFollowLiveroom: false};
        case 'SET_LIVEROOM_QRCODE':
            return {...state, liveroomQrcode: action.payload};
        default:
            return state;
    }
}





// WEBPACK FOOTER //
// ./src/reducers/followLiveroom.js